// @theme component
export const isStickyGamesBtnShown = 'isStickyGamesBtnShown';
